import React from "react";
import MapContextData from './MapContextData';
const MapContext = React.createContext<MapContextData>({map: null} as MapContextData);
export default MapContext;
